module.exports = __webpack_public_path__ + "img/Group-11560.a39899ed.svg";